<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="ah-detail-dialog return-dialog"
        top="4vh"
        append-to-body
        :before-close="() => onClose()"
        @open="onOpen"
    >
        <template slot="title">
            <span v-if="!sno">新增還款</span>
            <span v-else>編輯還款</span>
        </template>

        <div class="ah-panel">
            <div class="panel-body">
                <div class="ah-container">
                    <div style="text-align: right; margin-bottom: 10px">
                        <el-button v-if="drawdown && drawdown.repaymentList.length > 0" @click="onCopyLastReturnData">套用上期還款資料</el-button>
                    </div>
                    <el-form ref="form" :model="form" :rules="rules" :label-position="isMobile() ? 'top' : 'right'" label-width="150px" v-loading="isLoading">
                        <el-form-item prop="drawdown" label="還動撥借款">
                            <el-input :value="drawdownInfo" disabled />
                            <div style="font-size: 10pt; line-height: 170%; margin: 10px 0 0 0">
                                <div>未還金額：<Money :v="balanceAmt" /> 元</div>
                                <div v-if="isAmortization">固定繳款日：每月 {{ contrast.amortizationFixedPaymentDate }} 日</div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="drawdown">
                            <template slot="label"> 補登資料 <ah-tip>用於補登以前已還款紀錄，將不從現有銀行帳戶中扣款</ah-tip> </template>
                            <el-checkbox v-model="form.isMakeUpRegistration" />
                        </el-form-item>
                        <div></div>
                        <el-form-item prop="returnType" label="還款類型" v-if="!isAmortization">
                            <el-radio v-model="form.returnType" label="1" @input="onReturnTypeChanged">還本金＋利息</el-radio>
                            <el-radio v-model="form.returnType" label="2" @input="onReturnTypeChanged">只繳利息</el-radio>
                        </el-form-item>
                        <el-form-item prop="repaymentDate" label="還款日期">
                            <el-date-picker v-model="form.repaymentDate" value-format="timestamp" type="date" placeholder="選擇日期" :picker-options="{ disabledDate }" @change="onAutoFillDate">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="principalAmount" label="還款本金" :rules="isAmortization ? rules.principalAmount : []">
                            <money-input v-model="form.principalAmount" :disabled="!isAmortization" style="width: 290px; margin-right: 10px" @change="updateTotalAmt" />
                            <el-button v-if="isAmortization" @click="onFetchFullAmt" size="small">截至 {{ todayString }} 未還金額：<Money :v="balanceAmt" /> 元 </el-button>
                        </el-form-item>
                        <el-form-item prop="interestAmount" label="還款利息">
                            <money-input v-model="form.interestAmount" style="width: 350px" @change="updateTotalAmt" />
                        </el-form-item>
                        <el-form-item prop="totalAmount" label="扣款總額">
                            <money-input v-model="form.totalAmount" disabled style="width: 350px" />
                        </el-form-item>
                        <br />
                        <el-form-item prop="loanBankName" label="借款戶" v-show="false">
                            <el-input :value="contrast.loanBankName" disabled style="width: 350px" />
                        </el-form-item>
                        <el-form-item v-if="!form.isMakeUpRegistration" prop="repaymentBankSno" label="扣款銀行帳戶">
                            <ah-el-select-bank-account v-if="!isLoading" v-model="form.repaymentBankSno" document-type="loan" hide-borrower cny="TWD" />
                        </el-form-item>
                        <br />
                        <el-form-item label="匯費" v-if="!form.isMakeUpRegistration">
                            <div class="flex-block">
                                <el-form-item prop="reM_FEE_AMT">
                                    <money-input v-model="form.reM_FEE_AMT" style="width: 150px" @change="onAutoFillDate" />
                                </el-form-item>
                                <el-form-item prop="reM_FEE_PAY_DAT" :rules="form.reM_FEE_AMT ? rules.reM_FEE_PAY_DAT : []">
                                    <el-date-picker v-model="form.reM_FEE_PAY_DAT" value-format="timestamp" type="date" placeholder="選擇日期" disabled style="width: 150px; margin: 0 10px">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item prop="reM_FEE_BNK_SNO" :rules="form.reM_FEE_AMT ? rules.reM_FEE_BNK_SNO : []">
                                    <ah-el-select-bank-account v-if="!isLoading" v-model="form.reM_FEE_BNK_SNO" document-type="loan" hide-borrower :disabled="!form.reM_FEE_AMT" cny="TWD" />
                                </el-form-item>
                            </div>
                        </el-form-item>
                        <el-form-item prop="note" label="備註">
                            <el-input v-model="form.note" type="textarea" :rows="4" :maxlength="200" show-word-limit />
                        </el-form-item>
                    </el-form>
                    <div class="button-set">
                        <el-button v-if="sno && !isQR()" type="danger" :loading="isLoading" @click="onDelete"> 刪除 </el-button>
                        <el-button :loading="isLoading" @click="onClose()">取消</el-button>
                        <el-button v-if="!isQR()" type="primary" :loading="isLoading" @click="onSubmit">
                            <span v-if="sno">儲存</span>
                            <span v-else>新增</span>
                        </el-button>
                    </div>
                </div>
            </div>
            <div v-if="sno" class="panel-body">
                <div class="ah-container">
                    <div class="data-record">
                        <div v-if="creatorInfo" class="creator">資料建立：{{ creatorInfo }}</div>
                        <div v-if="editorInfo" class="editor">最後編輯：{{ editorInfo }}</div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';

export default {
    components: { ahElSelectBankAccount },
    props: {
        visible: Boolean,
        sno: Number,
        drawdown: {
            type: Object,
            default: () => {},
        },
        contrast: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isLoading: false,
            form: {
                isMakeUpRegistration: false,
                repaymentDate: null,
                principalAmount: 0,
                interestAmount: 0,
                totalAmount: 0,
                repaymentBankSno: null,
                note: null,
                reM_FEE_AMT: 0,
                reM_FEE_PAY_DAT: null,
                reM_FEE_BNK_SNO: null,
                returnType: '1', // 1: 還本金＋利息; 2: 只繳息 （僅前端使用，後端未存）
            },
            rules: {
                repaymentDate: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                principalAmount: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                interestAmount: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                repaymentBankSno: [{ required: true, message: '請輸入欄位', trigger: 'change' }],
                returnType: [{ required: true, message: '請選擇還款方式', trigger: 'change' }],
            },

            creator: null,
            createDate: null,
            editor: null,
            editDate: null,
        };
    },
    computed: {
        creatorInfo() {
            if (!this.form.crT_NAM || !this.form.crT_DAT) return false;

            return `${this.form.crT_NAM || '--'}, ${moment(this.form.crT_DAT).format('YYYY-MM-DD') || '--'}`;
        },
        editorInfo() {
            if (!this.form.upD_NAM || !this.form.upD_DAT) return false;

            return `${this.form.upD_NAM || '--'}, ${moment(this.form.upD_DAT).format('YYYY-MM-DD') || '--'}`;
        },
        isAmortization() {
            return this.drawdown?.repaymentWay === 2;
        },
        drawdownInfo() {
            return `${this.drawdown?.systemNo} ${this.drawdown?.summary}`;
        },
        balanceAmt() {
            const AMT = this.drawdown?.amount || 0;
            return AMT - _.sumBy(this.drawdown?.repaymentList, 'principalAmount');
        },
        todayString() {
            return moment().format('YYYY/MM/DD');
        },
    },
    methods: {
        onOpen() {
            if (this.sno) this.fetchData();
            else if (this.isAmortization) {
                this.form.principalAmount = 0;
            } else {
                this.form.principalAmount = this.drawdown?.amount;
            }
        },
        onClose(refresh) {
            this.form = {
                isMakeUpRegistration: false,
                repaymentDate: null,
                principalAmount: 0,
                interestAmount: 0,
                totalAmount: 0,
                repaymentBankSno: null,
                note: null,
                reM_FEE_AMT: 0,
                reM_FEE_PAY_DAT: null,
                reM_FEE_BNK_SNO: null,
                returnType: '1',
            };
            this.$refs.form.resetFields();
            this.$emit('close', refresh);
        },
        async fetchData() {
            const resp = await this.$api({
                method: 'GET',
                url: 'LoanReceipt/GetLoanReceiptRepaymentDetail',
                params: { sno: this.sno },
            });

            console.log('repay detail', resp);
            this.form = resp.data.detail;

            this.updateReturnType();
        },
        updateReturnType() {
            if (!this.isAmortization) {
                if (this.form.principalAmount === 0) {
                    this.form.returnType = '2';
                } else if (this.form.principalAmount === this.drawdown?.amount) {
                    this.form.returnType = '1';
                } else {
                    this.form.returnType = null;
                }
            }
        },
        onFetchFullAmt() {
            this.form.principalAmount = this.balanceAmt;
            this.updateTotalAmt();
        },
        updateTotalAmt() {
            this.form.totalAmount = this.form.principalAmount + this.form.interestAmount;
        },
        clearBankDataForMakeUp() {
            this.form.repaymentBankSno = null;
            this.form.reM_FEE_AMT = 0;
            this.form.reM_FEE_PAY_DAT = null;
            this.form.reM_FEE_BNK_SNO = null;
        },
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;
                        if (this.sno) await this.onUpdate();
                        else await this.onCreate();

                        this.$message({
                            showClose: true,
                            message: `已成功${this.sno ? '更新' : '建立'}還款`,
                            type: 'success',
                        });

                        this.onClose(true);
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        async onCreate() {
            if (this.form.isMakeUpRegistration) this.clearBankDataForMakeUp();
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/AddLoanReceiptRepayment',
                data: { ...this.form, loanReceiptDrawdownSno: this.drawdown?.sno },
            });
        },
        async onUpdate() {
            if (this.form.isMakeUpRegistration) this.clearBankDataForMakeUp();
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/UpdateLoanReceiptRepayment',
                data: { ...this.form, loanReceiptDrawdownSno: this.drawdown?.sno },
            });
        },
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此還款？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    method: 'POST',
                    url: 'LoanReceipt/DeleteLoanReceiptRepayment',
                    data: { sno: this.sno },
                });

                this.$message({
                    showClose: true,
                    message: '已成功刪除還款',
                    type: 'success',
                });
                this.onClose(true);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        disabledDate(date) {
            /* 結束日+14天是為了最後還款日期會因碰上國定假日而延期 */
            if (this.drawdown?.repaymentWay === 1) {
                return moment(date).isBefore(moment(this.drawdown?.drawdownDate)) || moment(date).isAfter(moment(this.contrast.repaymentEndDate).add(14, 'days'));
            }
            return moment(date).isBefore(moment(this.drawdown?.drawdownDate)) || moment(date).isAfter(moment(this.contrast.amortizationEndDate).add(14, 'days'));
        },
        onAutoFillDate() {
            if (this.form.reM_FEE_AMT) this.form.reM_FEE_PAY_DAT = this.form.repaymentDate;
            else {
                this.form.reM_FEE_PAY_DAT = null;
                this.form.reM_FEE_BNK_SNO = null;
            }
        },
        onReturnTypeChanged(v) {
            if (v === '1') {
                this.form.principalAmount = this.drawdown?.amount;
            } else if (v === '2') {
                this.form.principalAmount = 0;
            }
            this.updateTotalAmt();
        },
        async onCopyLastReturnData() {
            if (this.drawdown && this.drawdown.repaymentList.length > 0) {
                const lastReturn = _.maxBy(this.drawdown.repaymentList, 'repaymentDate');
                // console.log('lastReturn', lastReturn);

                const resp = await this.$api({
                    method: 'GET',
                    url: 'LoanReceipt/GetLoanReceiptRepaymentDetail',
                    params: { sno: lastReturn.sno },
                });
                const lastReturnFullData = resp.data.detail;
                // console.log('lastReturnFullData', lastReturnFullData)

                this.form.principalAmount = lastReturnFullData.principalAmount;
                this.form.interestAmount = lastReturnFullData.interestAmount;
                this.form.totalAmount = lastReturnFullData.totalAmount;
                this.form.repaymentBankSno = lastReturnFullData.repaymentBankSno;
                this.form.note = lastReturnFullData.note;
                this.form.reM_FEE_AMT = lastReturnFullData.reM_FEE_AMT;
                this.form.reM_FEE_BNK_SNO = lastReturnFullData.reM_FEE_BNK_SNO;

                if (this.form.reM_FEE_AMT && this.form.repaymentDate) {
                    this.form.reM_FEE_PAY_DAT = this.form.repaymentDate;
                }

                this.updateReturnType();
            }
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.ah-detail-dialog.return-dialog {
    > .el-dialog {
        max-width: 780px;
    }

    .data-record {
        font-size: 10pt;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .button-set {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }
    .flex-block {
        display: flex;
    }
}
</style>
